<div class="ecb-paid-registration-page">

  <div class="container">


    <!-- ======================================================= -->
    <!-- LOADING -->
    <!-- ======================================================= -->

    <div class="ecb-registration-state-card" *ngIf="isLoading">

      <div class="spinner-border" role="status">
      </div>

      <h3>
        Loading Registration
      </h3>

      <p>
        Please wait while we load your booking details.
      </p>

    </div>



    <!-- ======================================================= -->
    <!-- LOAD ERROR -->
    <!-- ======================================================= -->
    <div class="ecb-registration-error-card" *ngIf="!isLoading && loadError">

      <div class="ecb-registration-state-icon error">
        <i class="bi bi-exclamation-triangle"></i>
      </div>

      <h3>
        Unable to load registration
      </h3>

      <p>
        {{ loadError }}
      </p>

    </div>

    <div class="ecb-registration-error-card" *ngIf="!isLoading && alreadySubmitted">

      <div class="ecb-registration-state-icon">
        <i class="bi bi-check-circle"></i>
      </div>

      <h3>
        The form has already been submitted
      </h3>

      <p>
        This registration form has already been completed and submitted.
      </p>

    </div>
    <!-- ======================================================= -->
    <!-- REGISTRATION -->
    <!-- ======================================================= -->

    <div class="ecb-paid-registration-wrapper" *ngIf="
    !isLoading &&
    !alreadySubmitted &&
    !loadError
  ">


      <!-- ===================================================== -->
      <!-- HEADER -->
      <!-- ===================================================== -->

      <div class="ecb-registration-header">

        <div class="ecb-registration-header-icon">

          <i class="bi bi-clipboard-check"></i>

        </div>


        <div class="ecb-registration-header-content">

          <span class="ecb-registration-eyebrow">
            ECB Training
          </span>

          <h1>
            Course Registration
          </h1>

          <p>
            Please complete the information below to finalise
            your registration.
          </p>

        </div>

      </div>



      <!-- ===================================================== -->
      <!-- BOOKING INFORMATION -->
      <!-- ===================================================== -->

      <div class="ecb-booking-summary">

        <div class="ecb-booking-summary-icon">

          <i class="bi bi-check-circle"></i>

        </div>


        <div class="ecb-booking-summary-content">

          <span>
            Your Booking
          </span>

          <strong>
            {{ participant.courseTitle || 'Course Registration' }}
          </strong>

          <small>
            Booking Reference:
            REQ-00{{ orderId }}
          </small>

        </div>

      </div>


      <!-- ===================================================== -->
      <!-- SELECTED TRAINING -->
      <!-- ===================================================== -->

      <section class="ecb-registration-card" *ngIf="selectedTrainingCourses.length > 0">

        <div class="ecb-registration-card-header">

          <div class="ecb-registration-card-title">

            <span class="ecb-registration-card-icon">
              <i class="bi bi-box-seam"></i>
            </span>

            <div>

              <h2>
                Selected Training
              </h2>

              <p>
                Courses selected for this participant.
              </p>

            </div>

          </div>

        </div>


        <div class="ecb-registration-card-body">

          <div class="row g-3">

            <div class="col-12 col-md-6" *ngFor="let training of selectedTrainingCourses">

              <div class="h-100 d-flex align-items-center gap-3 p-3" style="
                  background: var(--ecb-primary-tint);
                  border: 1px solid var(--ecb-primary-soft);
                  border-radius: 8px;
                ">

                <span class="badge px-3 py-2" [style.backgroundColor]="
                    training.type === 'VOC'
                      ? '#9b2c20'
                      : training.type === 'COA'
                        ? '#7a5a13'
                        : 'var(--ecb-accent-color)'
                  " [style.color]="'#ffffff'" style="
                    min-width: 48px;
                    font-size: 10px;
                    font-weight: 700;
                    border-radius: 5px;
                  ">

                  {{ training.type }}

                </span>


                <div class="d-flex flex-column" style="min-width: 0;">

                  <strong *ngIf="training.code" style="
                      color: var(--ecb-dark-color);
                      font-size: 11px;
                      font-weight: 700;
                      text-transform: uppercase;
                    ">

                    {{ training.code }}

                  </strong>

                  <span style="
                      margin-top: 2px;
                      color: var(--ecb-deep-dark);
                      font-size: 12px;
                      line-height: 1.4;
                    ">

                    {{ training.name || training.code }}

                  </span>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>



      <!-- ===================================================== -->
      <!-- FORM -->
      <!-- ===================================================== -->

      <form #registrationForm="ngForm" novalidate>


        <!-- =================================================== -->
        <!-- PERSONAL DETAILS -->
        <!-- =================================================== -->

        <div class="ecb-voc-sub-section">

          <div class="ecb-voc-sub-section-header">

            <div>

              <i class="bi bi-person"></i>

              <span>
                Personal Details
              </span>

            </div>

            <small>
              Your booking information has been pre-filled.
            </small>

          </div>


          <div class="ecb-voc-sub-section-body">

            <div class="row g-4">


              <!-- First Name -->

              <div class="col-12 col-md-6">

                <div class="ecb-voc-form-group">

                  <label for="firstName">

                    First Name

                  </label>


                  <input id="firstName" type="text" class="form-control ecb-readonly-field"
                    [(ngModel)]="participant.firstName" name="firstName" readonly>

                </div>

              </div>



              <!-- Last Name -->

              <div class="col-12 col-md-6">

                <div class="ecb-voc-form-group">

                  <label for="lastName">

                    Last Name
                    <span>*</span>
                  </label>


                  <input id="lastName" type="text" class="form-control " [(ngModel)]="participant.lastName"
                    name="lastName" [maxlength]="250">

                </div>

              </div>



              <!-- Email -->

              <div class="col-12 col-md-6">

                <div class="ecb-voc-form-group">

                  <label for="emailAddress">

                    Email Address

                  </label>


                  <input id="emailAddress" type="email" class="form-control ecb-readonly-field"
                    [(ngModel)]="participant.emailAddress" name="emailAddress" readonly>

                </div>

              </div>



              <!-- Mobile -->

              <div class="col-12 col-md-6">

                <div class="ecb-voc-form-group">

                  <label for="mobileNumber">

                    Contact Number

                    <span>*</span>

                  </label>


                  <input id="mobileNumber" type="tel"   appPhoneNumberValidation class="form-control"
                    [(ngModel)]="participant.mobileNumber" name="mobileNumber" placeholder="Enter contact number">

                </div>

              </div>



              <!-- DOB -->

              <div class="col-12 col-md-6">

                <div class="ecb-voc-form-group">

                  <label for="dateOfBirth">

                    Date of Birth

                    <span class="ecb-optional">
                      Optional
                    </span>

                  </label>


                  <input id="dateOfBirth" type="date" class="form-control" [(ngModel)]="participant.dateOfBirth"
                    name="dateOfBirth">

                </div>

              </div>



              <!-- Course -->

              <div class="col-12 col-md-6">

                <div class="ecb-voc-form-group">

                  <label for="courseTitle">

                    Course

                  </label>


                  <input id="courseTitle" type="text" class="form-control ecb-readonly-field"
                    [(ngModel)]="participant.courseTitle" name="courseTitle" readonly>

                </div>

              </div>



              <!-- Address -->

              <div class="col-12">

                <div class="ecb-voc-form-group">

                  <label for="address">

                    Residential Address

                    <span class="ecb-optional">
                      Optional
                    </span>

                  </label>


                  <textarea id="address" class="form-control" rows="3" [(ngModel)]="participant.address" name="address"
                    placeholder="Enter residential address">
                  </textarea>

                </div>

              </div>


            </div>

          </div>

        </div>



        <!-- =======================================================
         EDUCATION
    ======================================================== -->
        <section class="ecb-registration-card">

          <div class="ecb-registration-card-header">

            <div class="ecb-registration-card-title">

              <span class="ecb-registration-card-icon">
                <i class="bi bi-book"></i>
              </span>

              <div>
                <h2>Education</h2>
                <p>Select your highest qualification.</p>
              </div>

            </div>

          </div>


          <div class="ecb-registration-card-body">

            <div class="row g-4">

              <div class="col-12 col-md-6">

                <div class="ecb-registration-form-group">

                  <label for="educationQualificationId">
                    Education
                  </label>

                  <select id="educationQualificationId" class="form-select" [(ngModel)]="participant.qualificationId"
                    name="educationQualificationId" (ngModelChange)="onEducationQualificationChange($event)">

                    <option [ngValue]="null">
                      Select highest education
                    </option>

                    <option *ngFor="let qualification of qualificationList" [ngValue]="qualification.id">
                      {{ qualification.qualificationName }}
                    </option>

                  </select>

                </div>

              </div>


              <div class="col-12 col-md-6">

                <div class="ecb-registration-form-group">

                  <label for="usi">
                    USI
                  </label>

                  <input id="usi" type="text" class="form-control" maxlength="20" [(ngModel)]="participant.usi"
                    name="usi" placeholder="Enter USI">

                </div>

              </div>

            </div>

          </div>

        </section>


        <!-- =======================================================
         QUALIFICATION CERTIFICATES
    ======================================================== -->
        <section class="ecb-registration-card">

          <div class="ecb-registration-card-header">

            <div class="ecb-registration-card-title">

              <span class="ecb-registration-card-icon">
                <i class="bi bi-award"></i>
              </span>

              <div>
                <h2>Qualification</h2>
                <p>Enter any relevant qualification and upload supporting evidence.</p>
              </div>

            </div>

          </div>


          <div class="ecb-registration-card-body">

            <div class="ecb-registration-form-group">

              <label>
                Qualification Certificates
              </label>

              <input #certificateFileInput type="file"
                accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp" multiple hidden
                (change)="onCertificateFilesSelected($event)">

              <!-- Uploaded certificate cards -->
              <div class="ecb-certificate-list" *ngIf="participant.qualificationCertificates?.length > 0">

                <div class="ecb-certificate-card"
                  *ngFor="let certificate of participant.qualificationCertificates; let certificateIndex = index">

                  <div class="ecb-certificate-card-header">

                    <strong>
                      Certificate {{ certificateIndex + 1 }}
                    </strong>

                    <button type="button" class="btn ecb-certificate-remove-button" [disabled]="certificate.isUploading"
                      (click)="removeQualificationCertificate(certificateIndex)" title="Remove certificate">

                      <i class="bi bi-trash"></i>
                      Remove

                    </button>

                  </div>


                  <div class="ecb-certificate-file-row">

                    <div class="ecb-certificate-file-icon">
                      <i class="bi bi-file-earmark"></i>
                    </div>

                    <div class="ecb-certificate-file-details">

                      <strong>
                        {{ certificate.fileName }}
                      </strong>

                      <span *ngIf="certificate.isUploading">
                        <span class="spinner-border spinner-border-sm"></span>
                        Uploading...
                      </span>

                      <span class="ecb-document-upload-success" *ngIf="certificate.fileUrl && !certificate.isUploading">

                        <i class="bi bi-check-circle-fill"></i>
                        Upload complete

                      </span>

                      <span class="ecb-document-upload-error" *ngIf="certificate.uploadError">

                        <i class="bi bi-exclamation-circle"></i>
                        {{ certificate.uploadError }}

                      </span>

                    </div>

                  </div>

                </div>

              </div>


              <!-- Always keep this visible so another certificate can be added -->
              <div class="ecb-multi-upload-zone ecb-certificate-add-zone">

                <button type="button" class="btn ecb-add-document-button" [disabled]="hasCertificateUploading()"
                  (click)="certificateFileInput.click()">

                  <ng-container *ngIf="!hasCertificateUploading()">
                    <i class="bi bi-plus-circle"></i>
                    Add a Certificate
                  </ng-container>

                  <ng-container *ngIf="hasCertificateUploading()">
                    <span class="spinner-border spinner-border-sm"></span>
                    Uploading...
                  </ng-container>

                </button>

              </div>


              <div class="ecb-document-upload-error mt-2" *ngIf="participant.certificateUploadError">
                <i class="bi bi-exclamation-circle"></i>
                {{ participant.certificateUploadError }}
              </div>

            </div>

          </div>

        </section>


        <!-- =======================================================
         VERIFICATION / MULTIPLE ID DOCUMENTS
    ======================================================== -->
        <section class="ecb-registration-card">

          <div class="ecb-registration-card-header">

            <div class="ecb-registration-card-title">

              <span class="ecb-registration-card-icon">
                <i class="bi bi-person-vcard"></i>
              </span>

              <div>
                <h2>Verification</h2>
                <p>Add one or more identity documents.</p>
              </div>

            </div>

          </div>


          <div class="ecb-registration-card-body">

            <div class="ecb-id-document-block" *ngFor="let idDocument of participant.idDocuments; let idIndex = index">

              <div class="ecb-id-document-heading">

                <strong>
                  ID Document {{ idIndex + 1 }}
                </strong>

                <button type="button" class="btn ecb-id-row-remove-button" *ngIf="participant.idDocuments.length > 1"
                  [disabled]="idDocument.isUploading" (click)="removeIdDocument(idIndex)" title="Remove ID document">
                  <i class="bi bi-trash"></i>
                </button>

              </div>


              <div class="row g-3 align-items-start">

                <div class="col-12 col-md-4">

                  <div class="ecb-registration-form-group">

                    <label [for]="'idType_' + idIndex">
                      ID Type
                    </label>

                    <!--  <select
                  class="form-select"
                  [id]="'idType_' + idIndex"
                  [(ngModel)]="idDocument.idType"
                  [name]="'idType_' + idIndex">

                  <option value="">
                    Select ID type
                  </option>

                  <option value="DRIVER_LICENCE">
                    Driver Licence
                  </option>

                  <option value="PASSPORT">
                    Passport
                  </option>

                  <option value="PROOF_OF_AGE">
                    Proof of Age
                  </option>

                  <option value="OTHER">
                    Other
                  </option>

                </select> -->

                    <select class="form-select" [id]="'idType_' + idIndex" [(ngModel)]="idDocument.idType"
                      [name]="'idType_' + idIndex">

                      <option value="">
                        Select ID type
                      </option>

                      <option *ngFor="let idType of identityTypesList" [value]="idType.code">
                        {{ idType.name }}
                      </option>

                    </select>

                  </div>

                </div>


                <div class="col-12 col-md-8">

                  <div class="ecb-registration-form-group">

                    <label>
                      ID Document
                    </label>

                    <input #idFileInput type="file"
                      accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp" hidden
                      [disabled]="!idDocument.idType || idDocument.isUploading"
                      (change)="onIdFileSelected($event, idIndex)">

                    <div class="ecb-id-upload-zone" [class.disabled]="!idDocument.idType || idDocument.isUploading">

                      <button type="button" class="btn ecb-id-upload-button"
                        [disabled]="!idDocument.idType || idDocument.isUploading" (click)="idFileInput.click()">

                        <ng-container *ngIf="!idDocument.isUploading">
                          <i class="bi bi-file-earmark-arrow-up"></i>
                          {{
                          idDocument.idType
                          ? (idDocument.fileName ? 'Replace File' : 'Select File')
                          : 'Select ID Type First'
                          }}
                        </ng-container>

                        <ng-container *ngIf="idDocument.isUploading">
                          <span class="spinner-border spinner-border-sm"></span>
                          Uploading...
                        </ng-container>

                      </button>

                    </div>


                    <div class="ecb-document-file-card mt-2" *ngIf="idDocument.fileName">

                      <div class="ecb-document-file-icon">
                        <i class="bi bi-file-earmark-person"></i>
                      </div>

                      <div class="ecb-document-file-info">

                        <strong>
                          {{ idDocument.fileName }}
                        </strong>

                        <span class="ecb-document-upload-success" *ngIf="idDocument.fileUrl && !idDocument.isUploading">
                          <i class="bi bi-check-circle-fill"></i>
                          Upload complete
                        </span>

                        <span class="ecb-document-upload-error" *ngIf="idDocument.uploadError">
                          <i class="bi bi-exclamation-circle"></i>
                          {{ idDocument.uploadError }}
                        </span>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>


            <button type="button" class="btn ecb-add-another-id-button" (click)="addIdDocument()">
              <i class="bi bi-plus-circle"></i>
              Add Another ID
            </button>

          </div>

        </section>


        <!-- =======================================================
         SUBMITTED DATE
    ======================================================== -->
        <section class="ecb-registration-card ecb-submitted-date-card">

          <div class="ecb-registration-card-body">

            <label class="ecb-submitted-date-label" for="submittedDate">
              Submitted Date
            </label>

            <div class="row g-3 align-items-center">

              <div class="col-12 col-md-5">

                <input id="submittedDate" type="date" class="form-control ecb-submitted-date-input"
                  [(ngModel)]="participant.submittedDate" name="submittedDate" readonly>

              </div>

              <div class="col-12 col-md-7">

                <div class="ecb-submitted-date-info">
                  <i class="bi bi-calendar-check"></i>
                  <span>
                    The submitted date is automatically set to the current date.
                  </span>
                </div>

              </div>

            </div>

          </div>

        </section>


        <!-- =================================================== -->
        <!-- SUBMIT ERROR -->
        <!-- =================================================== -->

        <div class="ecb-submit-message error" *ngIf="submitError">

          <i class="bi bi-exclamation-circle"></i>

          <span>
            {{ submitError }}
          </span>

        </div>



        <!-- =================================================== -->
        <!-- SUCCESS -->
        <!-- =================================================== -->

        <div class="ecb-submit-message success" *ngIf="submitSuccess">

          <i class="bi bi-check-circle-fill"></i>

          <div>

            <strong>
              Registration Submitted
            </strong>

            <span>
              Your registration details have been
              successfully submitted.
            </span>

          </div>

        </div>



        <!-- =================================================== -->
        <!-- FINAL SUBMISSION -->
        <!-- =================================================== -->

        <div class="ecb-voc-submit-card" *ngIf="!submitSuccess">


          <div class="ecb-voc-submit-info">

            <i class="bi bi-info-circle"></i>


            <div>

              <strong>
                Review before submitting
              </strong>

              <span>
                Please confirm all information and uploaded
                documents are correct before submitting.
              </span>

            </div>

          </div>


          <button type="button" class="btn ecb-voc-submit-button" [disabled]="
              isSubmitting ||
              hasUploadingFiles()
            " (click)="submitRegistration()">


            <ng-container *ngIf="!isSubmitting">

              <i class="bi bi-check-circle"></i>

              Submit Registration

            </ng-container>


            <ng-container *ngIf="isSubmitting">

              <span class="
                  spinner-border
                  spinner-border-sm
                ">
              </span>

              Submitting...

            </ng-container>

          </button>

        </div>


      </form>

    </div>

  </div>

</div>